/**
 * AgeCode component.
 */
import Circle from '@components/elements/progressCircle/progressCircle';

/**
 * Props for the AgeCode component.
 * @param {string} ageCode - Age code.
 * @param {boolean} margin - Margin of the age code.
 */
interface Props {
  ageCode?: string;
  margin?: boolean;
}

/**
 * Renders the age code component.
 * @param {string} ageCode - Age code.
 * @param {boolean} margin - Margin of the age code.
 * @returns {JSX.Element} Age code component.
 */
export default function AgeCode({ ageCode, margin }: Props) {
  return ageCode ? <Circle margin={margin} text={ageCode} /> : null;
}
